import { Component } from '@angular/core';

@Component({
  selector: 'app-what-is-vmg-webmaster',
  templateUrl: './what-is-vmg-webmaster.component.html',
  styleUrls: ['./what-is-vmg-webmaster.component.scss']
})
export class WhatIsVmgWebmasterComponent {
}
